var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooterPc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 26,
    viewBox: "0 0 342 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_6097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5188 0.36377H46.793V25.6921H50.5188V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.844 11.1387L51.9729 13.0277L59.844 14.9167V11.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7444 0.36377H52.3992C57.7188 1.0844 61.165 2.47669 63.7444 4.58262V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.447 0.36377H69.7212V25.6921H73.447V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5739 25.6913L78.7315 10.6279L76.229 13.1327L84.4286 25.6913H88.5739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1215 0.36377C83.1215 0.36377 82.758 3.76404 80.3394 9.01836L88.9863 0.36377H83.1285H83.1215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7444 21.3682C61.165 23.4811 57.7188 24.9713 52.3992 25.692H63.7444V21.3682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.259 0.36377H301.533V25.6921H305.259V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.866 0.36377H306.406C313.515 1.01447 317.499 5.96818 317.499 13.0139C317.499 20.0597 313.557 25.0414 306.406 25.6921H308.866C315.87 25.6921 321.47 20.4585 321.47 13.0139C321.47 5.56937 316.199 0.36377 308.866 0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.282 0.36377H277.563V25.6851H281.282V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.913 6.71684C294.913 1.03546 288.657 0.36377 286.658 0.36377H283.302C284.61 0.636644 290.964 1.33632 290.964 6.74482C290.964 13.4407 283.617 13.6576 283.617 13.6576C284.847 13.6576 286.001 14.2664 286.7 15.2809C290.782 21.2631 288.496 17.9117 293.348 25.6711H297.682L289.664 13.5317C291.949 13.0209 294.913 10.8659 294.913 6.72383V6.71684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.614 5.35292C327.614 3.04399 329.152 1.19684 331.906 0.238281C327.817 0.343233 324.503 2.86207 324.503 6.49339C324.503 16.3518 338.82 11.2232 338.82 19.6053C338.82 22.446 337.282 24.755 333.968 25.8255C338.575 25.7205 342 22.6629 342 18.255C342 8.2146 327.614 13.1753 327.614 5.35992V5.35292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.672 5.48561V0.5951C339.274 0.616089 335.87 0.47616 334.283 0.238281C334.283 0.238281 338.414 1.1758 340.672 5.48561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.433 20.4233V25.4678L331.417 25.8246C327.222 24.5582 325.482 21.7527 324.433 20.4233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.192 23.642L252.867 0.36377H249.092L244.192 23.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.525 0.36377L233.727 4.17701L230.037 23.9709L235.44 9.59251L240.515 25.6921H244.381L236.433 0.36377H232.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.405 0.36377L226.402 25.6921H230.309L221.271 0.36377H217.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72583 0.36377H0V25.6921H3.72583V0.36377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8761 6.80064C12.8761 12.6429 6.44505 12.9998 5.45242 13.0348C6.52893 13.0208 13.7849 13.0348 13.7849 19.2549C13.7849 25.475 5.59922 25.6919 5.22174 25.6919H7.93398C15.5184 25.6919 17.7064 22.7113 17.7064 19.1639C17.7064 16.0784 15.6373 13.6085 10.2268 12.9858C14.3161 12.2371 16.6089 9.85123 16.6089 6.89859C16.6089 3.35123 13.9247 0.370605 7.93398 0.370605H5.20776C6.51495 0.622489 12.8691 0.909356 12.8691 6.80763L12.8761 6.80064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.616 25.6921L143.063 0.36377H138.722L155.275 25.6921H159.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47 25.6914H145.489C141.742 23.0817 139.47 13.0278 139.47 13.0278V25.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.903 13.0273V0.36377H152.885C156.632 2.97344 158.903 13.0273 158.903 13.0273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.746 24.712V13.021H177.441C177.441 13.021 181.202 14.1894 181.202 18.0444V24.747C181.768 24.6071 183.775 24.1873 184.746 24.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.819 25.4333C172.024 25.8671 167.48 21.4521 167.48 12.7341C167.48 6.22013 169.347 1.37137 174.911 0C168.082 0 163.118 5.71636 163.118 13.021C163.118 22.4247 170.759 27.8192 178.819 25.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.593 5.33828V0.363815C183.146 0.384804 179.622 0.237879 177.98 0C177.98 0 182.831 1.25936 184.593 5.33828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2786 20.4727V25.5521L100.262 25.9089C96.0677 24.6285 94.3271 21.809 93.2786 20.4727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.517 5.42977V0.504279C108.119 0.525269 104.714 0.38534 103.128 0.147461C103.128 0.147461 107.259 1.09198 109.517 5.42977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.452 5.30392C96.452 2.98099 97.9899 1.11985 100.744 0.154297C96.6547 0.259248 93.3413 2.79908 93.3413 6.45139C93.3413 16.3798 107.657 11.2162 107.657 19.6543C107.657 22.516 106.12 24.8459 102.806 25.9164C107.413 25.8115 110.838 22.7329 110.838 18.2969C110.838 8.18659 96.452 13.1823 96.452 5.31092V5.30392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1428 5.86328L19.9502 25.6912H24.4589L28.1428 5.86328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6435 18.6113L38.167 25.6921H42.0746L33.0361 0.36377H29.1285L34.6579 15.8616L28.5483 17.135L35.6435 18.6113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.219 5.86328L113.026 25.6912H117.535L121.219 5.86328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.719 18.6113L131.243 25.6921H135.15L126.112 0.36377H122.204L127.734 15.8616L121.624 17.135L128.719 18.6113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.648 0.36377L210.184 15.8616L204.068 17.135L211.163 18.6113L213.686 25.6921H217.594L208.555 0.36377H204.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.978 25.6912L203.662 5.86328L195.469 25.6912H199.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.892 0.36377L266.428 15.8616L260.312 17.135L267.407 18.6113L269.93 25.6921H273.838L264.799 0.36377H260.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.222 25.6912L259.906 5.86328L251.713 25.6912H256.222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_6097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterPc);
export default __webpack_public_path__ + "static/media/LogoFooter__pc.cd3186997d0ff6d81413ba8d97f34d3b.svg";
export { ForwardRef as ReactComponent };